import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Input from '@jobcase/react_pattern_library/components/Input/InputRebrand';
import SearchRebrandLightSVG from '@jobcase/react_pattern_library/components/SVGIcon/icons/SearchRebrandLightSVG';
import SVGIcon from '@jobcase/react_pattern_library/components/SVGIcon';
import TimesLightSVG from '@jobcase/react_pattern_library/components/SVGIcon/icons/TimesLightSVG';
import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

const StyledInput = styled(Input)`
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  :hover {
    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
      -webkit-appearance: none;
    }
  }

  input[type="search"] {
    background-color: ${styles.color.jobcaseWhiteColor};
    border: 1px solid ${styles.color.inputBorderColor};
    color: ${styles.color.jobcaseBlackColor};
    padding-right: ${styles.spacing.extraTiny * 5}px;

    ::placeholder {
      color: ${styles.color.inputPlaceholder};
    }
  }
`;

const InputSearchIcon = styled(SVGIcon)`
  cursor: default;
  width: 22px;
  height: 22px;
  margin-top: -2px;
`;

const ResetIconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  right: 24px;
  top: 15px;

  svg {
    height: 22px;
  }
`;

const InputWrapper = styled.div`
  position: relative;
`;

const SearchWrapper = styled.div`
  padding: ${styles.spacing.tiny}px;
`;

const StyledTypography = styled(Typography)`
  font-family: ${styles.font.fontFamily};
  font-size: ${styles.font.fontSize.body};
  font-weight: 600;
  line-height: ${styles.font.lineHeight.h3};
  margin-bottom: ${styles.spacing.tiny + 4}px;
`;

const DropDownHeaderComponent = ({ value, onChange, resetQuery }) => (
  <SearchWrapper>
    <StyledTypography variant={VARIANTS.H2} className="dropdown-heading">Choose an account</StyledTypography>
    <InputWrapper>
      <StyledInput
        className="dropdown-input"
        iconFront={(
          <InputSearchIcon
            svgChild={SearchRebrandLightSVG}
            color={styles.color.textGrayColor}
          />
          )}
        value={value}
        placeholder="Search accounts"
        onChange={onChange}
        type={Input.TEXT_FIELD_TYPES.SEARCH}
      />
      {value && (
      <ResetIconWrapper onClick={resetQuery}>
        <SVGIcon svgChild={TimesLightSVG} color={styles.color.bodyTextColor} />
      </ResetIconWrapper>
      )}
    </InputWrapper>
  </SearchWrapper>
);

DropDownHeaderComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  resetQuery: PropTypes.func,
};

DropDownHeaderComponent.defaultProps = {
  value: '',
  onChange: () => {},
  resetQuery: () => {},
};

export default DropDownHeaderComponent;
